var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAnnounceRoom = function SvgAnnounceRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "announce-room_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".announce-room_svg__st1{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11 0 20 9 20 20s-9 20-20 20S0 31 0 20 9 0 20 0z",
    style: {
      fill: "#8b9c8f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 13.1 15 17h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1l1.8 5.3c.1.4.5.7.9.7h.1c.6 0 1.1-.6 1-1.2L14 23h1l5.4 3.9a1 1 0 0 0 1.6-.8V22c1.1 0 2-.9 2-2s-.9-2-2-2v-4.1c0-.8-.9-1.2-1.6-.8zM26 19c-.6 0-1 .4-1 1s.4 1 1 1h3c.6 0 1-.4 1-1s-.4-1-1-1h-3zM28.2 13.8c.4.4.4 1 0 1.4l-2 2c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2-2c.4-.4 1-.4 1.4 0zM28.2 24.8c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-2-2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2 2z",
    className: "announce-room_svg__st1"
  })));
};
export default SvgAnnounceRoom;